import React from 'react'
import { Box, Grid, Stack, Typography } from '@mui/material'
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { customStyles, justifyCenter, spaceBetween } from '../../../styles';
import { PreviewStackContainer } from '../preview-order/PreviewStackContainer';
import styled from '@emotion/styled';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { CaptionText } from '../../helpers';
import { animations } from '../../../utils/animations';

export const OrderSteps = ({status, active=false}) => {
   const style = {
      color: customStyles.colors.main
   }

   const Dashed = styled(Box)(() => (({
      border: `1px dashed ${ customStyles.colors.textColor }`, 
      width: '100%'
   })))

   const Solid = styled(Box)(() => (({
      border: `1px solid ${ customStyles.colors.main }`, 
      width: '100%'
   })))

   const CircleDisable = styled(Box)(() => (({
      borderRadius:  '50%',
      width: 20,
      height: 20,
      border: `1px solid ${ customStyles.colors.textColor }`,
      opacity: .6
      // backgroundColor: customStyles.colors.main
   })))

   const TruckIcon = styled(LocalShippingOutlinedIcon)(() => (({
      fontSize: 35,
      color: customStyles.colors.main,
      borderRadius: '50%', padding: .2
      // backgroundColor: customStyles.colors.main
   })))
   const CircleActive = styled(Box)(() => (({
      borderRadius:  '50%',
      width: 20,
      height: 20,
      // border: `1px solid ${ customStyles.colors.main }`
      backgroundColor: customStyles.colors.main
   })))

   const Text = styled(Typography)(() => (({
      fontSize: 10,
      textAlign: 'center'
   })))

//   { value: "ACCEPTED", label: "Aceptado" },
//   { value: "ACTIVE", label: "Activo" },
//   { value: "CANCELED", label: "Cancelado" },
//   { value: "ROUTED", label: "En Ruta" },
//   { value: "DONE", label: "Surtido" },
  return (
   <Stack text="Enviar a esta dirección">
      <Grid container alignItems="center" justifyContent="center" width="100%">
         <Grid item xs={1}  sx={ justifyCenter } >
            { 
               status === 'ACTIVE'
               ? <TruckIcon className={ animations.ruber } fontSize='medium' sx={{ color: customStyles.colors.main, borderRadius: '50%', padding: .2 }}/>
               : <CircleDisable />
            }
         </Grid>
         <Grid item xs={2}  sx={ justifyCenter } >
            {/* {
               status === 'ACTIVE'
               ?  <Dashed />
               : <Solid />
            } */}
            <Dashed />
         </Grid>
         {
            //------------------------------------------------------------------
         }
         <Grid item xs={1}  sx={ justifyCenter } >
            {
               status === 'ACCEPTED'
               ?
               <TruckIcon />
               :
               <CircleDisable />
            }
         </Grid>
         <Grid item xs={2}  sx={ justifyCenter } >
         {/* {
               status === 'ACCEPTED'
               ? <Solid />
               :  <Dashed />
            } */}
            <Dashed />
         </Grid>
         {
            //------------------------------------------------------------------
         }
         <Grid item xs={1}  sx={ justifyCenter } >
         {
               status === 'ROUTED' 
               ?
               <TruckIcon />
               :
               <CircleDisable />
            }
         </Grid> 
         <Grid item xs={2}  sx={ justifyCenter } >
            {/* {
               !status === 'ROUTED'
               ? <Solid /> 
               :  <Dashed />
            } */}
            <Dashed />
         </Grid>
         {
            //------------------------------------------------------------------
         }
         <Grid item xs={1}  sx={ justifyCenter } >
         {
               status === 'DONE' 
               ?
               <TruckIcon />
               :
               <CircleDisable />
            }
         </Grid>
      </Grid>

      <Grid container>
         <Grid item xs={ 3 }>
            <Text component="p" variant="caption" sx={{...style}}>Creado</Text>
         </Grid>
         <Grid item xs={ 3 }>
            <Text component="p" variant="caption" sx={{...style}}>Aceptado</Text>
         </Grid>
         <Grid item xs={ 3 }>
            <Text component="p" variant="caption" sx={{...style}}>En Ruta</Text>
         </Grid>
         <Grid item xs={ 3 }>
            <Text component="p" variant="caption" sx={{...style}}>Finalizado</Text>
         </Grid>
      </Grid>
   </Stack>
  )
}
